import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    Alert,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: 18,
        fontWeight: 500,
    },
}));

const ReassignActivityDialog = ({ confirmOpen, handleConfirmOpen, newCaseId, handleCloseConfirmationDialog, handleReassignActivity, attachmentCount }) => {
    const classes = useStyles();
    return (
        <Dialog open={confirmOpen} onClose={() => handleConfirmOpen(false)}>
            <DialogTitle>
                <Typography className={classes.title} color="primary" variant="body1">
                    Reassign activity?
                </Typography>
            </DialogTitle>            
            <DialogContent>
                {attachmentCount > 0 &&
                    <Alert severity="warning" style={{marginBottom: '10px'}}>
                        {attachmentCount} attachment{attachmentCount === 1 ? "" : "s"} linked to this activity will remain in Case Files unless deleted manually!!
                    </Alert>
                }
                <DialogContentText>Are you sure you want to reassign this activity to case {newCaseId}?</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseConfirmationDialog} color="secondary" variant="text">
                    Cancel
                </Button>
                <Button onClick={handleReassignActivity} color="secondary" variant="text" data-cy="confirm_reassign_activity">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReassignActivityDialog;
